import isEmpty from '@tinkoff/utils/is/empty';

export const formatOptionalField = <T>(value: T) => {
  if (isEmpty(value)) {
    return null;
  }

  return value;
};
